import React from 'react';
import { minBreakpoints } from '@noths/polaris-client-styles';
import Head from 'next/head';

interface Props {
  href: string;
  desktop?: boolean;
}

export const ImagePreloadLink = ({ href, desktop = false }: Props) => {
  const media = desktop
    ? `(min-width: ${minBreakpoints.MEDIUM}px)`
    : `(max-width: ${minBreakpoints.MEDIUM - 1}px)`;

  return (
    <Head>
      <link rel="preload" as="image" href={href} media={media} />
    </Head>
  );
};
